<script setup lang="ts">
import { computed } from 'vue';
import { useAlertsStore, type AlertNotification } from '@/store/AlertsStore';

const alertsStore = useAlertsStore();

const getColorFor = (n: AlertNotification) => {
  switch (n.type) {
    case 'success':
      return 'success';
    case 'error':
      return 'error';
    default:
      return 'info';
  }
};

const getIconFor = (n: AlertNotification) => {
  switch (n.type) {
    case 'success':
      return 'mdi-check-circle';
    case 'error':
      return 'mdi-alert-circle';
    default:
      return 'mdi-information-outline';
  }
};

const notifications = computed(() => alertsStore.notifications);
</script>

<template>
  <v-snackbar
    v-for="n in notifications"
    :key="n.id"
    :model-value="true"
    :timeout="5000"
    location="bottom right"
    :color="getColorFor(n)"
    elevation="6"
    @timeout="alertsStore.remove(n.id)"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-2" :icon="getIconFor(n)" color="white" size="20" />
      <span class="text-white">{{ n.message }}</span>
    </div>
    <template #actions>
      <v-btn
        variant="text"
        icon="mdi-close"
        color="white"
        @click="alertsStore.remove(n.id)"
      />
    </template>
  </v-snackbar>
</template>

<style scoped></style>
